import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerLinks.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              {footerLinks.partners.title}
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              {footerLinks.partners.description}
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500">
              <i className="ri-sun-line text-sm text-background-50"></i>
            </div>
            <span className="text-sm text-background-300 font-heading">今日看料</span>
          </div>

          <p className="text-xs text-background-500">
            美好生活从今日开始 &copy; {new Date().getFullYear()} 今日看料
          </p>

          <div className="flex items-center gap-4">
            <a href="#contact" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
              <i className="ri-mail-line text-sm"></i>
            </a>
            <a href="#contact" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#contact" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
              <i className="ri-weibo-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}